module.exports = __webpack_public_path__ + "static/media/ac_china.f1db6e2e.png";